function LoadingCircleIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="255" height="254" viewBox="0 0 255 254" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M237.421 190.499C252.107 165.061 257.519 135.317 252.735 106.337C247.95 77.3557 233.264 50.9305 211.181 31.5634C189.097 12.1963 160.981 1.08568 131.623 0.124617C102.266 -0.836447 73.4833 8.41152 50.18 26.2928C26.8767 44.174 10.4944 69.5822 3.82443 98.1881C-2.84552 126.794 0.609563 156.828 13.601 183.172C26.5924 209.516 48.3163 230.54 75.0713 242.662C101.826 254.785 131.957 257.256 160.329 249.653L159.284 245.754C131.814 253.114 102.642 250.722 76.7374 238.985C50.8331 227.248 29.7999 206.892 17.2216 181.386C4.64325 155.88 1.29802 126.801 7.75589 99.1047C14.2138 71.4085 30.0752 46.8082 52.6375 29.4955C75.1998 12.1828 103.067 3.22887 131.491 4.15937C159.915 5.08988 187.137 15.8472 208.519 34.5985C229.901 53.3498 244.119 78.9348 248.752 106.994C253.384 135.053 248.144 163.851 233.925 188.48L237.421 190.499Z"
                fill="url(#paint0_linear_116_7923)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_116_7923"
                    x1="127.469"
                    y1="0.0566442"
                    x2="187.157"
                    y2="231.817"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8FCA94" />
                    <stop offset="1" stopColor="#5D9461" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default LoadingCircleIcon;
